const cmsPlaceholderKeys = {
    all: ['cmsPlaceholders'] as const,
};

export default cmsPlaceholderKeys;
